// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"fae906cc","355":"fae906cc","558":"fae906cc","736":"fae906cc","742":"fae906cc","783":"fae906cc","882":"fae906cc","954":"fae906cc"}[chunkId] + ".chunk.css";
};